import { useLayoutEffect, useRef } from "react";

/**
 * คอลัมน์ที่เกาะซ้าย (เลขที่ -> รหัส -> ชื่อ -> ชื่อเล่น) กว้างตามเนื้อหา ไม่ตายตัว
 * จึงวัดความกว้างจริงของหัวคอลัมน์แต่ละตัวส่งให้ CSS (--att-seq-w / --att-code-w / --att-name-w) ใช้คำนวณตำแหน่ง left ของตัวถัดไป
 * วัดใหม่ทุกครั้งที่ความกว้างเปลี่ยน (ค้นหา, ซ่อน/แสดงคอลัมน์, ชื่อยาวขึ้น) คอลัมน์ที่ถูกซ่อน = 0
 * deps: ค่าที่เปลี่ยนแล้วหัวคอลัมน์ถูกถอด/ใส่ใหม่ (เช่น ซ่อนคอลัมน์รหัส) ต้องผูก observer ใหม่
 */
export default function useStickyColumns(deps = []) {
  const tableRef = useRef(null);
  const seqRef = useRef(null);
  const codeRef = useRef(null);
  const nameRef = useRef(null);

  useLayoutEffect(() => {
    const table = tableRef.current;
    if (!table) return undefined;

    const heads = { seq: seqRef, code: codeRef, name: nameRef };
    const sync = () => {
      Object.entries(heads).forEach(([key, ref]) => table.style.setProperty(`--att-${key}-w`, `${ref.current?.offsetWidth || 0}px`));
    };
    sync();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(sync);
    Object.values(heads).forEach((ref) => ref.current && observer.observe(ref.current));
    return () => observer.disconnect();
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  return { tableRef, seqRef, codeRef, nameRef };
}
